<script lang="ts">
  import Branche from '@/generated/classes/Branche';
  import Convention from '@/generated/classes/Convention';
  import SectionEtablissementIdentite from '@/generated/sections/SectionEtablissementIdentite.vue';
  import { storeSession } from '@/generated/stores';
  import {RessourceFwkButton, FwkButtons, RessourceAppSection, AppSections} from '@/ressources/globalRessources';
  import FormeJuridique from '@/generated/classes/FormeJuridique';
  import UserProfile, { EnumProfile } from "@/framework/base/classes/UserProfile";
  import { defineComponent } from "vue";
  import { FieldStatus, SectionStatus } from "@/framework/base/components/FieldInfo.ts";
  import {GenSection, RessourceGenSection} from "@/generated/ressources/generatedRessources.ts";

  export default defineComponent({
    components: {},
    extends: SectionEtablissementIdentite,
    data() {
      return {
        conv3252: false,
        conv1790: false,
        isAssociation: false,
        getAssociation: false,
        t3252ReadOnly: this.etablissement.t3252 != 0,
        t1790ReadOnly: this.etablissement.t1790 != 0,
        soumisTvaReadOnly: this.etablissement.soumisTva != null,
        etablissementNom: this.etablissement.nom,
        refresh: false,
        lastRefresh: false,
        siretValid: false,
        resetConvention: false,
        lastId: 0,
        status: new SectionStatus(false, false, false),
      };
    },
    // created(): void {
    //   this.loadConvention()
    // },
    computed: {
      ressource () {
        if (this.editEtablissement.id < 0) {
          return RessourceAppSection(AppSections.NEW_ETABLISSEMENT_HEADER);
        } else {
          return RessourceGenSection(GenSection.ETABLISSEMENT_IDENTITE);
        }
      },
      saveLabel(): string {
        if (this.editEtablissement.siretValid) {
          return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
        } else {
          return RessourceFwkButton(FwkButtons.VERIFIER).label;
        }
      },
      association(): boolean {
        if (!this.getAssociation && this.editEtablissement.formeJuridiqueId > 0) {
          this.loadAssociation();
        }
        return this.isAssociation;
      },
      isSalarie(): boolean {
        let res = false;
        const user = storeSession.connectedUser;
        if (user) {
          res = UserProfile.hasProfile(user, EnumProfile.salarie);
        }
        return res;
      },
      isAdmin(): boolean {
        const user = storeSession.connectedUser;
        if (user) {
          return UserProfile.hasProfile(user, EnumProfile.admin);
        }
        return false;
      },
      resetConventionId(): boolean {
        if (this.lastId != this.editEtablissement.id) {
          this.resetConventionData();
        } else if (this.editEtablissement.conventionId > 0) {
          this.loadConvention();
        }
        return this.resetConvention;
      },
      saveButton(): boolean {
        return this.showButton && (!this.allReadOnly || this.editEtablissement.id <= 0);
      },
      fields(): string[] {
        return ['ALIAS', 'NOM', 'VILLE', 'FORME_JURIDIQUE_ID', 'SIRET', 'BRANCHE_ID', 'CONVENTION_ID', 'T3252', 'T1790', 'TRANCHE_EFFECTIF_ID', 'SOUMIS_TVA', 'DATE_CREATION'];
      }
    },
    methods: {
      resetConventionData() {
        this.lastId = this.editEtablissement.id;
        this.t3252ReadOnly = this.editEtablissement.t3252 != 0;
        this.t1790ReadOnly = this.editEtablissement.t1790 != 0;
        this.soumisTvaReadOnly = this.editEtablissement.soumisTva != null;
        this.resetConvention = !this.resetConvention;
        this.displayMap.clear();
      },
      loadConvention() {
        Convention.get(this.editEtablissement.conventionId).then((res) => {
          if (res.code == '1790') {
            this.conv1790 = true;
            this.displayMap.set("T1790", this.editEtablissement.id > 0 && (this.editEtablissement.t1790 == 0 || !!this.fiche));
            if (this.conv1790 != (res.code == '1790')) {
              this.refresh = !this.refresh;
            }
          }
          else if (res.code == '3252') {
            this.conv3252 = true;
            this.displayMap.set("T3252", this.editEtablissement.id > 0 && (this.editEtablissement.t3252 == 0 || !!this.fiche));
            if (this.editEtablissement.t3252 == 0) {
              Branche.get(this.editEtablissement.brancheId).then((branche) => {
                if (branche.code == '9002Z') {
                  this.t3252 = 2;
                } else {
                  this.t3252 = 1;
                }
                this.statusT3252(new FieldStatus(false, true, 0));
                this.t3252ReadOnly = true;
                this.readOnlyMap.set("T3252", this.t3252ReadOnly);
                this.refresh = !this.refresh;
              });
            }
          }
        });
      },
      loadAssociation() {
        FormeJuridique.get(this.editEtablissement.formeJuridiqueId).then((res) => {
          this.isAssociation = res.code.startsWith('92');
          this.getAssociation = true;
          this.displayMap.set("SOUMIS_TVA", this.editEtablissement.id > 0 && this.isAssociation && (this.editEtablissement.soumisTva == null || !!this.fiche));
          this.refresh = !this.refresh;
        });
      },
      isDisplayed(value: string): boolean {
        let res = true;
        if (this.refresh != this.lastRefresh || this.siretValid != this.editEtablissement.siretValid) {
          this.lastRefresh = this.refresh;
          this.siretValid = this.editEtablissement.siretValid;
          this.displayMap.clear();
        }
        if (this.displayMap.size == 0) {
          const keepConvention = (this.editEtablissement.id > 0 && this.conv3252 && this.editEtablissement.t3252 == 0) ||
            this.editEtablissement.id > 0 && this.conv1790 && this.editEtablissement.t1790 == 0;
          this.displayMap.set("ALIAS", this.editEtablissement.id > 0 && !!this.fiche);
          this.displayMap.set("NOM", this.editEtablissement.siretValid);
          this.displayMap.set("VILLE", this.editEtablissement.siretValid && (this.editEtablissement.ville == '' || !!this.fiche));
          this.displayMap.set("FORME_JURIDIQUE_ID", this.editEtablissement.id > 0 && (this.editEtablissement.formeJuridiqueId == 0 || !!this.fiche));
          this.displayMap.set("SOUMIS_TVA", !this.isSalarie && this.editEtablissement.id > 0 && this.association && (this.editEtablissement.soumisTva == null || !!this.fiche));
          this.displayMap.set("SIRET", this.editEtablissement.siret == '' || !!this.fiche);
          this.displayMap.set("BRANCHE_ID", this.editEtablissement.siretValid && (this.editEtablissement.brancheId == 0 || !!this.fiche));
          this.displayMap.set("CONVENTION_ID", this.editEtablissement.siretValid && (this.editEtablissement.conventionId == 0 || keepConvention || !!this.fiche));
          this.displayMap.set("T3252", this.editEtablissement.id > 0 && this.conv3252 && (this.editEtablissement.t3252 == 0 || !!this.fiche));
          this.displayMap.set("T1790", this.editEtablissement.id > 0 && this.conv1790 && (this.editEtablissement.t1790 == 0 || !!this.fiche));
          this.displayMap.set("TRANCHE_EFFECTIF_ID", !this.isSalarie && this.editEtablissement.id > 0 && (this.editEtablissement.trancheEffectifId == 0 || !!this.fiche));
          this.displayMap.set("DATE_CREATION", !this.isSalarie && this.editEtablissement.id > 0 && (this.editEtablissement.dateCreation == new Date(1901, 1, 1, 0, 0, 0, 0) || !!this.fiche));
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },
      readOnly(value: string): boolean {
        let res = false;
        if (!this.editEtablissement.canUpdate) {
          return true;
        }
        if (this.etablissementNom != this.editEtablissement.nom) {
          this.etablissementNom = this.editEtablissement.nom;
          this.readOnlyMap.clear();
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("ALIAS", false);
          this.readOnlyMap.set("NOM", this.editEtablissement.nom != '');
          this.readOnlyMap.set("VILLE", this.editEtablissement.ville != '');
          this.readOnlyMap.set("FORME_JURIDIQUE_ID", (this.editEtablissement.id > 0 && this.editEtablissement.formeJuridiqueId > 0) || this.editEtablissement.formeJuridiqueInsee);
          this.readOnlyMap.set("SOUMIS_TVA", this.soumisTvaReadOnly);
          this.readOnlyMap.set("SIRET", this.isAdmin || (this.editEtablissement.id > 0 || this.editEtablissement.siretValid));
          this.readOnlyMap.set("BRANCHE_ID", (this.editEtablissement.id > 0 && this.editEtablissement.brancheId > 0) || this.editEtablissement.brancheInsee);
          this.readOnlyMap.set("CONVENTION_ID", (this.editEtablissement.id > 0 && this.editEtablissement.conventionId > 0) || this.editEtablissement.conventionInsee);
          this.readOnlyMap.set("T3252", this.t3252ReadOnly);
          this.readOnlyMap.set("T1790", this.t1790ReadOnly);
          this.readOnlyMap.set("TRANCHE_EFFECTIF_ID", this.editEtablissement.trancheEffectifId != 0);
          this.readOnlyMap.set("DATE_CREATION", true);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },
      isRequired(value: string): boolean {
        let res = false;
        if (value == 'ALIAS') {
          res = false;
        } else if (value == 'NOM') {
          res = true;
        } else if (value == 'VILLE') {
          res = true;
        } else if (value == 'FORME_JURIDIQUE_ID') {
          res = true;
        } else if (value == 'SOUMIS_TVA') {
          res = this.association;
        } else if (value == 'SIRET') {
          res = true;
        } else if (value == 'BRANCHE_ID') {
          res = true;
        } else if (value == 'CONVENTION_ID') {
          res = true;
        } else if (value == 'T3252') {
          res = true;
        } else if (value == 'T1790') {
          res = true;
        } else if (value == 'TRANCHE_EFFECTIF_ID') {
          res = true;
        } else if (value == 'DATE_CREATION') {
          res = false;
        }
        return res;
      },
      picto(): string {
        return 'SectionPictoEtablissement'
      },
      sectionSave(): void {
        this.saveFailed = false;
        if (this.checkFields()) {
          if (this.editEtablissement.siretValid) {
            this.editEtablissement.verifySiret = false;
            this.autoClose = true;
            this.allowClearRef = false;
            this.t3252ReadOnly = this.editEtablissement.t3252 != 0;
            this.t1790ReadOnly = this.editEtablissement.t1790 != 0;
            this.soumisTvaReadOnly = this.editEtablissement.soumisTva != null;
          } else {
            this.editEtablissement.verifySiret = true;
            this.autoClose = false;
            this.allowClearRef = false;
          }
          this.save();
          this.displayMap.clear();
        } else {
          this.saveFailed = true;
        }
      }
    }
  })

</script>
